import { createContext } from 'react';

type AchievementsSummaryContextType = {
    [type: string]: {
        totalProgress: number;
        hasAchieved: number;
        description: string;
        name: string;
    };
};

const AchievementsSummaryContext = createContext<AchievementsSummaryContextType>({});

export default AchievementsSummaryContext;
